export const iconFontAwesomeTextformattingParagraph = (
	<i className="fa-solid fa-paragraph"></i>
);
